import React from 'react'
import PropTypes from 'prop-types'
import {Text, Button, VStack} from '@chakra-ui/react'
import {useIntl} from 'react-intl'

const PickupPointTooltip = ({selectedStore, onConfirm}) => {
    const {formatMessage} = useIntl()

    return (
        <VStack align="stretch" spacing={3}>
            <Text color="gray.600">
                {selectedStore.address1}, {selectedStore.city}
            </Text>
            {/* Opening hourse placeholder*/}
            <Button variant="primary" size="sm" onClick={() => onConfirm(selectedStore)}>
                {formatMessage({
                    defaultMessage: 'Select this point',
                    id: 'pickup_point_tooltip.button.select',
                })}
            </Button>
        </VStack>
    )
}

PickupPointTooltip.propTypes = {
    selectedStore: PropTypes.object.isRequired,
    onConfirm: PropTypes.func.isRequired,
}

export default PickupPointTooltip
